import { InjectionToken } from '@angular/core';

export const SERVICEMESH_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>(
  'SERVICEMESH_MOCK_API_DEFAULT_DELAY'
);
